import { CheckIcon, CogIcon, HelpCircleIcon, XIcon } from 'lucide-react'

import { useQuoteSettings } from 'components/quote_explorer/QuoteSettingsProvider'
import { Button, DropdownMenu, Switch, Tooltip } from 'slab'

export default function SettingsDropdown () {
  const { includeEmployeeCostImpact, setincludeEmployeeCostImpact, hasEmployeeCostImpactSettingAccess } = useQuoteSettings()

  if (!hasEmployeeCostImpactSettingAccess) {
    return
  }

  return (
    <DropdownMenu
      align='end'
      trigger={
        <Button variant='secondary' size='small' data-testid='settings-dropdown-trigger'>
          <CogIcon className='w-4 h-4' />
        </Button>
      }
    >
      <DropdownMenu.Item onSelect={() => false}>
        <Switch
          checked={includeEmployeeCostImpact}
          onChange={() => setincludeEmployeeCostImpact(!includeEmployeeCostImpact)}
          label={
            <span className='flex items-center gap-2'>
              Include employee cost impact
              <Tooltip
                content='When enabled, all individuals with access to this Quote will see the "Employee Cost Impact" tab.'
                delayDuration={1}
              >
                <HelpCircleIcon className='w-4 h-4 text-gray-500' />
              </Tooltip>
            </span>
            }
          uncheckedIcon={XIcon}
          checkedIcon={CheckIcon}
        />
      </DropdownMenu.Item>
    </DropdownMenu>
  )
}
